const CURRENCY = process.env.REACT_APP_CURRENCY || "AED";

export const currencyCode = CURRENCY;

export const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "" || Number.isNaN(Number(value))) return "—";
  return `${CURRENCY} ${Number(value).toFixed(2)}`;
};

export const formatDate = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
};

export const formatDateTime = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};
